import { useEffect } from 'react';
import {
  selectAuthenticationStatus,
  useDispatch,
  useSelector,
} from '@bonanza-social/toolkit/state';
import { fetchGames, selectGamesState } from '../state/games/games.slice';
import {
  fetchCategories,
  selectCategoriesState,
} from '../state/categories/categories.slice';
import {
  fetchJackpots,
  selectJackpotsState,
} from '../state/jackpots/jackpots.slice';

const useGames = () => {
  const dispatch = useDispatch();
  const authenticationStatus = useSelector(selectAuthenticationStatus);
  const gamesState = useSelector(selectGamesState);
  const categoriesState = useSelector(selectCategoriesState);
  const jackpotsState = useSelector(selectJackpotsState);

  useEffect(() => {
    if (gamesState === 'idle') {
      dispatch(fetchGames(authenticationStatus));
    }
  }, [gamesState, authenticationStatus, dispatch]);

  useEffect(() => {
    if (categoriesState === 'idle') {
      dispatch(fetchCategories(authenticationStatus));
    }
  }, [categoriesState, authenticationStatus, dispatch]);

  useEffect(() => {
    if (jackpotsState === 'idle') {
      dispatch(fetchJackpots());
    }
  }, [jackpotsState, dispatch]);
};

export default useGames;
